export const walletCategories = [
  { value: true, text: 'pro' },
  { value: false, text: 'individual' }
];
